<template>
  <div class="listing-top-bar bg-gray-600 p-4 text-light text-left">
    <div class="inline-block mr-2">Listing:</div>

    <div class="active-buttons mr-2 p-1 inline-block" role="group">
      <button
        class="text-xs"
        :class="buttonStyle('active')"
        @click.prevent="toggleListings(true)"
      >
        Active
      </button>
      <button
        class="text-xs"
        :class="buttonStyle('inactive')"
        @click.prevent="toggleListings(false)"
      >
        Inactive
      </button>
    </div>

    <v-select
      :options="selectableListings"
      :clearable="false"
      ref="selectListing"
      label="address"
      :value="address"
      @input="loadListing($event)"
      class="vs-listing bg-white text-gray-700 inline-block rounded z-10"
      ignore
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      toggle: "active",
      selectableListings: [],
    };
  },
  computed: {
    ...mapGetters(["me"]),
    address() {
      if (this.listing) {
        return `${this.listing.address} ${this.listing.city}, ${this.listing.state} : ${this.listing.id}`;
      }
      return "";
    },
  },
  methods: {
    loadListing(item) {
      if (item == null) {
        return;
      }
      window.location = `/listing/${item.id}/info`;
    },
    buttonStyle(button) {
      let str = "btn";

      if (button === this.toggle) {
        str += " active";
      }

      return str;
    },
    getActiveListings() {
      let vm = this;
      vm.$http.get("/homes/active?includeCoList=1").then((response) => {
        // eslint-disable-next-line
        vm.parseSelectableListings(response.data);
      });
    },
    toggleListings(active) {
      if (active) {
        this.toggle = "active";
        this.getActiveListings();
      } else {
        this.toggle = "inactive";
        this.getInactiveListings();
      }
    },
    getInactiveListings() {
      let vm = this;
      vm.$http.get("/homes/inactive?includeCoList=1").then((response) => {
        // eslint-disable-next-line
        vm.parseSelectableListings(response.data);
      });
    },
    parseSelectableListings(data) {
      let selectableListings = [];

      data.forEach((v) => {
        selectableListings.push({
          address: `${v.address} ${v.city}, ${v.state}`,
          id: v.id,
        });
      });

      this.selectableListings = selectableListings.sort((a, b) => {
        if (a.address < b.address) {
          return -1;
        }
        if (a.address > b.address) {
          return 1;
        }
        return 0;
      });
    },
  },
  props: {
    listing: Object,
  },
  mounted() {
    this.getActiveListings();
  },
  watch: {
    me() {
      if (
        typeof this.me.tokenUser.preferences !== "undefined" &&
        typeof this.me.tokenUser.preferences[719] !== "undefined"
      ) {
        let langCode = this.me.tokenUser.preferences[719].PREFvalue;
        if (typeof langCode !== "undefined" && langCode === "fr-CA") {
          window.Localize.initialize({
            key: "VlbE8RtdbnJqb",
            targetLanguage: this.langCode
            // other options go here, separated by commas
          });
        }
      }
    },
  },
};
</script>

<style lang="scss">
.listing-top-bar {
  .vs-listing,
  .vs-listing.vs--open {
    width: 280px;
  }

  .vs-listing.vs--open.rounded {
    border-radius: 0.25rem 0.25rem 0 0 !important;
  }

  .vs-listing .vs__selected {
    width: 232px;
    margin: 3px 2px 0;
    overflow: hidden;
    white-space: nowrap;
  }
  .vs-listing .vs--open .vs__selected {
    flex: 1;
  }

  .dropdown-menu {
    overflow: scroll;
    max-height: 500px;
  }
}

.active-buttons {
  background: #575656;
  border-radius: 3px;
  padding-right: 4px;
  padding-top: 8px;

  .btn {
    border-radius: 3px;
    margin-left: 4px;

    color: #999;

    &.active,
    &:hover {
      background: #999;
      color: #fff;
    }
  }
}
</style>
